<template>
  <header>
    <nav>
      <span @click='$emit("changeContent", "TopPage")'> Top </span>
      <!-- <span @click='$emit("changeContent", "about")'> About </span> -->
      <!-- <span @click='$emit("changeContent", "gallery")'> Gallery </span>       -->
      <span @click='$emit("changeContent", "Contact")'> Contact </span>      
    </nav>
  </header>
</template>

<script>
export default {
  name: "header-nav"
};
</script>

<style>
header {
  position: absolute;
  top: 0;
  left: 15%;
  display: flex;
  width: 70%;
  height: calc(50px + 2vh);
  background-color: rgba(0,0,0,0.5);
}

nav {
  display: inline-flex;
  align-items: center;
  margin: 0 1em 0 auto;
}

nav span {
  display: block;
  text-align: center;
  padding: 0 1vw;
  font-size: calc(1em + 1vw);
  cursor: pointer;  
}

nav span:hover {
  color: #00f8b2;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue